// extracted by mini-css-extract-plugin
export default {"fire":"StoveFire_fire__MSDDA","fireMobile":"StoveFire_fireMobile__ugLgN","fireDesktop":"StoveFire_fireDesktop__65+EK","flicker":"StoveFire_flicker__hysIU"};